import { type ComponentPropsWithoutRef, type ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import cx from 'clsx';
import { IconShortcutAccountStatementsOutlined } from '@repo/monochrome-icons';
import styles from './actions.module.css';

interface QuoteActionsProps extends ComponentPropsWithoutRef<'div'> {
  pdfUrl?: string;
  onDownloadClick?: () => void;
}

export function QuoteActions({
  pdfUrl,
  onDownloadClick,
  className,
  ...props
}: QuoteActionsProps): ReactNode {
  const handleDownloadClick = (): void => {
    if (onDownloadClick) {
      onDownloadClick();
    }
  };

  return (
    <div className={cx(styles.actions, className)} {...props}>
      <a
        className="btn"
        data-test-quote-actions-download
        href={pdfUrl}
        onClick={handleDownloadClick}
        rel="noopener noreferrer"
        target="_blank"
        type="button"
      >
        <IconShortcutAccountStatementsOutlined className="mr-8" />
        <FormattedMessage id="quote.preview.cta.download" />
      </a>
    </div>
  );
}
